export const QUALITY = 0
export const SECURITY = 1
export const STANDARDS = 2
export const TRAINING = 3
export const IMPROVEMENT = 4

export const INVALID = -2
export const UNKNOWN = -1
export const DONE_NOT_PLANNED = 0
export const DONE_PLANNED = 1
export const PLANNED_EXPIRED = 2
export const PENDING_PLANNED = 3
export const PENDING_REPLANNED = 4
export const REPLANNED_EXPIRED = 5
export const DONE_PLANNED_REPLANNED = 6
export const EXPIRED_WITH_REPLANNED = 7

export const DATE_TYPES = Object.freeze({ daily: 0, weekly: 1, monthly: 2 })

export const AUDITS = 'audits'
export const AUDIT5S_SOURCE = 'audits'
export const HES_TOUR = 'hestour'
export const HSE_PRODUCTION = 'hseproduction'
export const Q_AUDITS = 'qaudits'
export const QNN_SOURCE = 'qnn'
export const LOGISTIC_SOURCE = 'logistics'
export const LPAS_SOURCE = 'lpas'
export const CHECKLIST_SOURCE = 'checklist'
export const MACHINES_SOURCE = 'machines'
export const ILUO_SOURCE = 'iluo'
export const NO_OBS_SOURCE = [AUDIT5S_SOURCE, LPAS_SOURCE, ILUO_SOURCE]
export const OBSERVATIONS_SOURCE = 'observations'
export const REL = 'rel'
export const AUDIT_FIVES_SOURCE = 'auditfives'
export const CORE_TEAM_SOURCE = 'coreteam'
export const EIGHTQB_SOURCE = 'eightqb'
export const CIL_SOURCE = 'cil'
export const PROCESS_SOURCE = 'process'
export const MASTER_AUDIT_SOURCE = 'master-audit'

export const PLANNER_STATUS = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  STARTED: 'STARTED',
}

const OPEN = 0
const PENDING = 1
const COMPLETED = 2

export const AUDITS_STATUS = {
  open: OPEN,
  pending: PENDING,
  completed: COMPLETED,
}

export const AUDITS_STATUS_LABELS = [
  { value: OPEN, label: 'audits.messages.open' },
  { value: PENDING, label: 'audits.messages.pending_signing' },
  { value: COMPLETED, label: 'common.messages.completed' },
]

export const OBSERVATION_STATUS_CLASS = {
  0: 'done-not-planned',
  1: 'done-planned',
  2: 'planned-expired',
  3: 'planned',
  4: 'replanned',
  5: 'replanned-expired',
  6: 'done-replanned',
  7: 'expired-with-replanned',
}

export const LABELGROUP_FROM_SOURCE = {
  'audits': 'common.messages.audits',
  'checklist': 'common.messages.checklist',
  'hestour': 'common.messages.hes_tour',
  'hseaudit': 'common.messages.menu_observation_hse_audit',
  'hseproduction': 'common.messages.hse_prod',
  'iluo': 'common.messages.iluo',
  'logistics': 'common.messages.logistics',
  'lpa': 'common.messages.lpa',
  'lpainj': 'common.messages.menu_lpa_injection',
  'lpapaint': 'common.messages.menu_lpa_paint',
  'lpastock': 'common.messages.menu_lpa_stock',
  'machines': 'common.messages.machines_audit',
  'observations': 'common.messages.observations',
  'qaudits': 'common.messages.qaudits',
  'qnn': 'common.messages.qnn',
  'rel': 'sources.messages.observation_rel',
  'shiftchange': 'sources.messages.shift_change',
  'standards': 'common.messages.standards',

  // LPA Sources

  'auditfives': 'common.messages.audit_fives',
  'cil': 'sources.messages.cil',
  'coreteam': 'common.messages.core_team',
  'eightqb': 'common.messages.eightqb',
  'lpas': 'common.messages.lpas',
  'gemba_walk': 'common.messages.gemba_walk',
  'quality_audit': 'common.messages.quality_audit',
  'security_audit': 'common.messages.security_audit',
  'production': 'common.messages.production',
  'production_start': 'common.messages.production_start',
  'product_audit': 'common.messages.product_audit',
  'clean_audit': 'common.messages.clean_audit',
  'process': 'common.messages.process',
  'kamishibai_audit': 'common.messages.kamishibai_audit',
  'assessments_audit': 'common.messages.assessments_audit',
  'routes': 'common.messages.routes',
  'maintenance': 'common.messages.maintenance',
  'auditcaplog': 'sources.messages.aud_cap_log',
  'audit': 'audits.messages.audit',
  'system_audit': 'common.messages.system_audit',
  'production_audit': 'common.messages.production_audit',
}

export const OBSERVER_KEYS = Object.freeze({ overall: 'is_overall_observer', auditors: 'observers' })
export const AUDITOR_KEYS = Object.freeze({ overall: 'is_overall_auditor', auditors: 'auditors' })

export const OK_COMPLIANCE_TYPE = 1
export const NOK_COMPLIANCE_TYPE = 0

export const DAILY_FREQUENCY = 'daily'
export const WEEKLY_FREQUENCY = 'weekly'
export const MONTHLY_FREQUENCY = 'monthly'

export const MASTER_AUDITS_URL = 'master-audits'

export const DEFAULT_SCORE_GOAL = 80
